import { type TouchEvent, useRef } from "react";

const CLOSE_THRESHOLD_PX = 60;

export const useSwipeToClose = (onClose: () => void, enabled = true) => {
	const startYRef = useRef<number | null>(null);
	const closedRef = useRef(false);

	const onTouchStart = (e: TouchEvent<HTMLDivElement>) => {
		startYRef.current =
			e.touches?.[0]?.clientY ?? e.targetTouches?.[0]?.clientY ?? null;
		e.stopPropagation();
	};

	const onTouchMove = (e: TouchEvent<HTMLDivElement>) => {
		if (enabled && startYRef.current != null) {
			const y =
				e.touches?.[0]?.clientY ?? e.targetTouches?.[0]?.clientY ?? null;
			if (
				y != null &&
				y - startYRef.current > CLOSE_THRESHOLD_PX &&
				!closedRef.current
			) {
				closedRef.current = true;
				onClose();
			}
		}
		e.stopPropagation();
	};

	const onTouchEnd = (e: TouchEvent<HTMLDivElement>) => {
		startYRef.current = null;
		closedRef.current = false;
		e.stopPropagation();
	};

	return { onTouchStart, onTouchMove, onTouchEnd };
};
